import { render } from "./NotificationsCenter.vue?vue&type=template&id=4aab1f6c"
import script from "./NotificationsCenter.vue?vue&type=script&lang=ts"
export * from "./NotificationsCenter.vue?vue&type=script&lang=ts"
script.render = render

export default script